export default "__VITE_ASSET__CbQzuGrw__"